import React from 'react';

const CcSvgIcon = () => {
  const tenantData = JSON.parse(localStorage.getItem('tenant_data'));

  return (
    <svg
      style={{ marginRight: 4 }}
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3 0.584473H1.7C0.76245 0.584473 0 1.34692 0 2.28447V12.4845C0 13.422 0.76245 14.1845 1.7 14.1845H15.3C16.2376 14.1845 17 13.422 17 12.4845V2.28447C17 1.34692 16.2376 0.584473 15.3 0.584473ZM7.65 5.68447H5.1V9.08447H7.65V10.7845H5.1C4.16245 10.7845 3.4 10.022 3.4 9.08447V5.68447C3.4 4.74692 4.16245 3.98447 5.1 3.98447H7.65V5.68447ZM13.6 5.68447H11.05V9.08447H13.6V10.7845H11.05C10.1125 10.7845 9.35 10.022 9.35 9.08447V5.68447C9.35 4.74692 10.1125 3.98447 11.05 3.98447H13.6V5.68447Z"
        fill={tenantData?.settings['general-theme']?.themeHeaderTextColor}
      />
    </svg>
  );
};

export default CcSvgIcon;
